import { SortDirection } from '../../api-util/sort-direction';

import { UserListModel } from './user-list.model';

export interface UserListModelSort {
  _id?: SortDirection;
  active?: SortDirection;
  firstName?: SortDirection;
  fullName?: SortDirection;
  isImplementer?: SortDirection;
  lastName?: SortDirection;
  name?: SortDirection;
  roleCode?: SortDirection;
  title?: SortDirection;
}

export const UserListRequestFields: (keyof UserListModel)[] = [
  '_id',
  'active',
  'avatarUrl',
  'firstName',
  'fullName',
  'initials',
  'isImplementer',
  'lastName',
  'name',
  'roleCode',
  'teamIds',
  'title',
  'isConfirmed',
];

export class UserListRequest {
  fields?: (keyof UserListModel)[] = UserListRequestFields;
  page?: number = 0;
  pageSize?: number = 500;
  searchText?: string | null = null;
  sort?: UserListModelSort | null = null;
  teamIds: string[] = [];
}
